import { cva } from '@/styled-system/css';

export const pageLayoutStyles = cva({
    base: {
        maxWidth: '{sizes.contentMaxWidth}',
        boxSizing: 'border-box',
        display: 'block',
        margin: '0 auto',
        minHeight: {
            mdToXxl: 'calc(100vh - {sizes.footerHeightLg} - {sizes.topNavHeight})',
            md: 'calc(100vh - {sizes.footerHeightXl} - {sizes.topNavHeight})',
        },
        minWidth: '{sizes.smallestSupportedDeviceWidth}',
        paddingTop: {
            base: 'sm',
            smToXl: 0,
        },
        paddingBottom: 0,
        '& *': {
            boxSizing: 'border-box',
        },
    },
});
